module.exports = __webpack_public_path__ + "img/item_questionmark.f1179839.png";